import { Store, StoreStatus } from '../types/store'
import { Order } from '../types/order'
import { Organization } from '../types/organization'
import { mockProducts } from './mockProducts'

export const mockOrganizations: Organization[] = [
  {
    id: 'org_1',
    name: 'Lincoln High School',
    contactName: 'Sarah Miller',
    contactEmail: 'sarah.m@lincolnhs.edu',
    defaultTimezone: 'America/Chicago',
    defaultDeliveryAddress: '123 School Ln, Springfield, IL',
    storeCount: 3,
  },
  {
    id: 'org_2',
    name: 'Westside Soccer Club',
    contactName: 'Mike Johnson',
    contactEmail: 'mike@westsidesoccer.org',
    defaultTimezone: 'America/New_York',
    defaultDeliveryAddress: '456 Field Rd, Brooklyn, NY',
    storeCount: 1,
  },
]

export const mockStores: Store[] = [
  {
    id: 'store_1',
    name: 'Lincoln HS Football Fall 2023',
    organizationId: 'org_1',
    organizationName: 'Lincoln High School',
    slug: 'lincoln-football-fall-23',
    supportEmail: 'support@printer.com',
    supportPhone: '(555) 123-4567',
    settings: {
      isPublished: true,
      orderingEnabled: true,
      scheduleEnabled: true,
      timezone: 'America/Chicago',
      openDate: new Date(Date.now() - 86400000 * 5).toISOString(), // Opened 5 days ago
      closeDate: new Date(Date.now() + 86400000 * 2).toISOString(), // Closes in 2 days
      closingSoonThreshold: 48,
      forceOpen: false,
      forceClosed: false,
      pauseOrdering: false,
    },
    messaging: {
      comingSoonMessage:
        'Get ready for the season! Our team store will open soon with exclusive gear.',
      openWindowMessage: 'Order your gear now before the store closes!',
      closedMessage: 'This store is now closed. Thank you for your orders!',
      estimatedTimeline:
        'Orders will be produced and shipped approximately 2 weeks after the store closes.',
    },
    products: mockProducts,
    stats: {
      ordersCount: 145,
      revenue: 4500.0,
      lastUpdated: new Date().toISOString(),
    },
    createdAt: new Date().toISOString(),
  },
  {
    id: 'store_2',
    name: 'Westside Soccer Spring',
    organizationId: 'org_2',
    organizationName: 'Westside Soccer Club',
    slug: 'westside-soccer-spring',
    supportEmail: 'support@printer.com',
    settings: {
      isPublished: true,
      orderingEnabled: false,
      scheduleEnabled: true,
      timezone: 'America/New_York',
      openDate: new Date(Date.now() + 86400000 * 10).toISOString(), // Opens in 10 days
      closeDate: new Date(Date.now() + 86400000 * 20).toISOString(),
      closingSoonThreshold: 24,
      forceOpen: false,
      forceClosed: false,
      pauseOrdering: false,
    },
    messaging: {
      comingSoonMessage:
        'Spring gear coming soon! Get ready for an amazing season.',
      openWindowMessage: '',
      closedMessage: '',
      estimatedTimeline: 'Orders ship within 3 weeks of store closing.',
    },
    products: mockProducts,
    stats: {
      ordersCount: 0,
      revenue: 0,
      lastUpdated: new Date().toISOString(),
    },
    createdAt: new Date().toISOString(),
  },
  {
    id: 'store_3',
    name: 'Lincoln HS Band',
    organizationId: 'org_1',
    organizationName: 'Lincoln High School',
    slug: 'lincoln-band',
    supportEmail: 'support@printer.com',
    settings: {
      isPublished: true,
      orderingEnabled: false,
      scheduleEnabled: true,
      timezone: 'America/Chicago',
      openDate: new Date(Date.now() - 86400000 * 20).toISOString(),
      closeDate: new Date(Date.now() - 86400000 * 5).toISOString(), // Closed 5 days ago
      closingSoonThreshold: 24,
      forceOpen: false,
      forceClosed: false,
      pauseOrdering: false,
    },
    messaging: {
      comingSoonMessage: '',
      openWindowMessage: '',
      closedMessage:
        'This store is closed. If you placed an order, check your email for confirmation.',
      estimatedTimeline: '',
    },
    products: mockProducts,
    stats: {
      ordersCount: 89,
      revenue: 2100.5,
      lastUpdated: new Date().toISOString(),
    },
    createdAt: new Date().toISOString(),
  },
]

export const mockOrders: Order[] = [
  {
    id: 'ord_123',
    storeId: 'store_1',
    storeName: 'Lincoln HS Football Fall 2023',
    customerName: 'John Doe',
    customerEmail: 'john@example.com',
    fulfillmentMethod: 'ship-to-home',
    items: [],
    total: 125.5,
    status: 'received',
    paymentStatus: 'paid',
    createdAt: new Date(Date.now() - 3600000).toISOString(),
  },
  {
    id: 'ord_124',
    storeId: 'store_1',
    storeName: 'Lincoln HS Football Fall 2023',
    customerName: 'Jane Smith',
    customerEmail: 'jane@example.com',
    fulfillmentMethod: 'bulk-ship',
    items: [],
    total: 45.0,
    status: 'in-production',
    paymentStatus: 'paid',
    createdAt: new Date(Date.now() - 86400000).toISOString(),
  },
]
